import { IWageSend } from 'src/types/wage';
import { WageFormData } from 'src/screens/General/screens/Wages/components/WageForm';
import moment from 'moment';

export const groupWage = (dataForm: Partial<WageFormData>): Partial<IWageSend> => {
    const { amount, providerDropDown, workedDays, workedHours, periodStart, periodEnd, ...data } = dataForm;
    const dataSend: Partial<IWageSend> = { ...data };
    if (providerDropDown) {
        dataSend.provider = providerDropDown.value;
    }
    if (amount) {
        dataSend.amount = parseFloat(`${amount}`);
    }
    if (periodStart) {
        dataSend.periodStart = moment(periodStart)
            .set('hour', 0)
            .set('minute', 0)
            .set('second', 0)
            .format('YYYY-MM-DD HH:mm');
    }

    if (periodStart) {
        dataSend.periodEnd = moment(periodEnd)
            .set('hour', 23)
            .set('minute', 59)
            .set('second', 0)
            .format('YYYY-MM-DD HH:mm');
    }

    if (workedDays) {
        dataSend.workedDays = +workedDays;
    }
    if (workedHours) {
        dataSend.workedHours = +workedHours;
    }
    return dataSend;
};
